/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import {
  AbstractRestService,
  arrayOf,
  identity,
  privilegedTokenOf,
  RestSettings,
} from '@gh/core-data';

import { Observable } from 'rxjs';
import { FeeExclusionItemDto, FeeExclusionUpdateDto } from './fee-exclusions.dto';
import {
  FeeExclusionsListItemMapper,
  FeeExclusionsUpdateMapper,
} from './fee-exclusions-list-item.mapper';

export type FeeExclusionGridFilter = {
  showDeleted: boolean;
  searchString: string;
};

@Injectable()
export class FeeExclusionRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  update(dto: FeeExclusionUpdateDto): Observable<any> {
    return this.httpPut(`${this.bp}/fee-exclusions`, dto,  privilegedTokenOf(FeeExclusionsUpdateMapper));
  }

  get(searchString: string): Observable<FeeExclusionItemDto[]> {
    return this.httpGet(`${this.bp}/fee-exclusions?showDeleted=true&searchString=${searchString}`,  arrayOf(FeeExclusionsListItemMapper));
  }

  delete(id: ID): Observable<any> {
    return this.httpDelete(`${this.bp}/fee-exclusions/${id}`, void 0, identity());
  }

}
